import { useCallback, useEffect, useRef, useState } from 'react'

/** A boolean that flips true on `trigger()` and auto-reverts after `duration` ms. */
export function useTransientFlag(duration = 1500): { active: boolean; trigger: () => void } {
  const [active, setActive] = useState(false)
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const clear = useCallback(() => {
    if (timeoutRef.current !== null) {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = null
    }
  }, [])

  const trigger = useCallback(() => {
    clear()
    setActive(true)
    timeoutRef.current = setTimeout(() => {
      setActive(false)
      timeoutRef.current = null
    }, duration)
  }, [clear, duration])

  useEffect(() => clear, [clear])

  return { active, trigger }
}
